/**
 * Status Badge — Colored pill badge for request status
 */

import React from 'react';
import { FaCheck, FaTimes, FaClock, FaChevronRight, FaBan } from 'react-icons/fa';

const STATUS_CONFIG = {
  pending: {
    label: 'Pending',
    className: 'wrms-badge-pending',
    icon: <FaClock size={9} />,
  },
  approved: {
    label: 'Approved',
    className: 'wrms-badge-approved',
    icon: <FaCheck size={9} />,
  },
  rejected: {
    label: 'Rejected',
    className: 'wrms-badge-rejected',
    icon: <FaTimes size={9} />,
  },
  cancelled: {
    label: 'Cancelled',
    className: 'wrms-badge-cancelled',
    icon: <FaBan size={9} />,
  },
  on_hold: {
    label: 'On Hold',
    className: 'wrms-badge-on-hold',
    icon: <FaClock size={9} />,
  },
  hold: {
    label: 'On Hold',
    className: 'wrms-badge-on-hold',
    icon: <FaClock size={9} />,
  },
  processing: {
    label: 'In Review',
    className: 'wrms-badge-processing',
    icon: <FaChevronRight size={9} />,
  },
};

const StatusBadge = ({ status, className = '' }) => {
  const config = STATUS_CONFIG[status?.toLowerCase()] || STATUS_CONFIG.pending;

  return (
    <span className={`wrms-badge ${config.className} ${className}`}>
      {config.icon}
      {config.label}
    </span>
  );
};

export default StatusBadge;
